import React from "react";
import { PROCESS_STEPS } from "../lib/siteData";
import Reveal from "./Reveal";

export default function Process() {
  return (
    <section id="process" className="relative py-20 lg:py-28 bg-white overflow-hidden" data-testid="process-section">
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#123E73]" />
            <span className="text-xs tracking-[0.3em] font-semibold text-[#123E73]">HOW WE WORK</span>
          </div>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-[44px] leading-[1.08] tracking-tight text-[#0A192F] max-w-3xl mb-14 lg:mb-16">
            A proven six-step process.
          </h2>
        </Reveal>

        {/* Desktop horizontal timeline */}
        <div className="hidden lg:block relative" data-testid="process-timeline-desktop">
          <div className="absolute top-[38px] left-0 right-0 h-px bg-slate-300" />
          <div className="grid grid-cols-6 gap-4">
            {PROCESS_STEPS.map((s, i) => (
              <Reveal key={s.num} delay={i * 80}>
                <div className="relative pt-0" data-testid={`process-step-${s.num}`}>
                  <div className="relative z-10 w-[76px] h-[76px] flex items-center justify-center bg-white border-2 border-[#123E73] text-[#123E73] font-display font-bold text-xl mx-auto transition-all duration-500 hover:bg-[#F5A400] hover:border-[#F5A400] hover:text-[#0A192F]">
                    {s.num}
                  </div>
                  <div className="mt-6 text-center">
                    <h3 className="font-display text-base font-bold text-[#0A192F] mb-2 tracking-tight">
                      {s.title}
                    </h3>
                    <p className="text-[13px] text-slate-600 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* Mobile vertical timeline */}
        <div className="lg:hidden space-y-5 relative" data-testid="process-timeline-mobile">
          <div className="absolute left-[37px] top-4 bottom-4 w-px bg-slate-300" />
          {PROCESS_STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 50}>
              <div className="relative flex items-start gap-5" data-testid={`process-step-mobile-${s.num}`}>
                <div className="relative z-10 w-[76px] h-[76px] shrink-0 flex items-center justify-center bg-white border-2 border-[#123E73] text-[#123E73] font-display font-bold text-lg">
                  {s.num}
                </div>
                <div className="pt-2">
                  <h3 className="font-display text-lg font-bold text-[#0A192F] mb-1 tracking-tight">
                    {s.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
